import React from 'react';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';

const viewActions = (props) => {
    let actions = props.data.map((action,index) => {
        let status = '';
        if(props.status && props.status.length > 0){
            status = props.status.filter(st => {
                return st.value === action.statusId;
            }).reduce((_,el) => {
                return el.label
            },'N/A')
        }
        if(action.actiontype === 1){
            return (
            <div className="p-col-12" key={index}>
                <div className="card card-w-title">
                <h1>Ticket Action</h1>
                <div className="p-grid">

                    <div className="p-col-12 p-md-12 p-lg-3">
                        <label className="label">Ticket Number</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.ticketNumber} placeholder="Ticket Number" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                        <label className="label">Ticket PNR</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.ticketPnr}   placeholder="Ticket PNR" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Ticket Airline</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.ticketAirline} placeholder="Ticket Airline" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Ticket From Airport</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.ticketFromAirport}  placeholder="Ticket From Airport" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Ticket To Airport</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.ticketToAirport}  placeholder="Ticket To Airport" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-3">
                    <label className="label">Date Of Journey</label>
                        <div className="mt1">
                            <InputText placeholder="Date Of Journey" value={action.ticketDateOfJourney}/>
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Return Ticket Number</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.returnTicketNumber} placeholder="Return Ticket Number" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Return Ticket Number</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.returnTicketPnr} placeholder="Return Ticket PNR" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Return Ticket Airline</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.returnTicketAirline}  placeholder="Return Ticket Airline" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Return Ticket From Airport</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.returnTicketFromAirport} placeholder="Return Ticket From Airport" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Return Ticket To Airport</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.returnTicketToAirport} placeholder="Return Ticket To Airport" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-3">
                    <label className="label">Return Date Of Journey</label>
                        <div className="mt1">
                            <InputText placeholder="Return Date Of Journey" value={action.returnTicketDateOfJourney}/>
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-9">
                    <label className="label">Return Date Of Journey</label>
                        <div className="mt1">
                            <InputTextarea rows={3} className="p-col-12" value={action.comments} cols={30} placeholder="Comments..." autoResize={true} />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-3">
                    <label className="label">Ticket Cancel Before Date1</label>
                        <div className="mt1">
                            <InputText placeholder="Ticket Cancel Before Date" value={action.ticketCancelBeforeDate1}/>
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                        <label className="label">Ticket Cancel Value Before Date1</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.ticketCancelValueBeforeDate1}  placeholder="Ticket Value" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-3">
                    <label className="label">Ticket Cancel Before Date2</label>
                        <div className="mt1">
                            <InputText placeholder="Ticket Cancel Before Date" value={action.ticketCancelBeforeDate2} />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Ticket Cancel Value Before Date2</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.ticketCancelValueBeforeDate2} placeholder="Ticket Value" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-3">
                    <label className="label">Ticket Cancel Value Before Date3</label>
                        <div className="mt1">
                            <InputText placeholder="Ticket Cancel Before Date" value={action.ticketCancelBeforeDate3} />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-12 p-lg-3">
                    <label className="label">Ticket Cancel Value Before Date3</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={action.ticketCancelValueBeforeDate3}placeholder="Ticket Value" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-3">
                    <label className="label">Status</label>
                        <div className="mt1">
                            <InputText className="p-col-12" value={status} placeholder="Ticket Status" />
                        </div> 
                    </div>

                    <div className="p-col-12 p-lg-12"><hr/></div>  
                    </div>
                </div>
            </div>
            )
        } else if(action.actiontype === 2){
            return (
                <div className="p-col-12" key={index}>
                    <div className="card card-w-title">
                    <h1>Visa Action</h1>
                    <div className="p-grid">
    
                    <div className="p-col-12 p-md-6 p-lg-3">
                    <label className="label">Exit Reentry Visa No</label>
                        <div className="mt1">
                                <InputText className="p-col-12" value={action.exitreentryvisanumber}  placeholder="Exit Reentry Visa No"/>
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Exit Reentry Issue Date</label>
                            <div className="mt1">
                                <InputText placeholder="Exit Reentry Issue Date" value={action.exitreentryvisaissuedate} />
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Exit Reentry Expiry Date</label>
                            <div className="mt1">
                                <InputText placeholder="Exit Reentry Expiry Date" value={action.exitreentryvisaexpirydate} />
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Visiting Country Visa No</label>
                            <div className="mt1">
                            <InputText className="p-col-12" value={action.visitingcountryvisanumber}/>
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Visiting Country Issue Date</label>
                            <div className="mt1">
                                <InputText placeholder="Visiting Country Issue Date" value={action.visitingcountryissuedate} />
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Visiting Country Expiry Date</label>
                            <div className="mt1">
                                <InputText placeholder="Visiting Country Expiry Date" value={action.visitingcountryexpirydate} />
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Visa Status</label>
                            <div className="mt1">
                                <InputText className="p-col-12" value={status} placeholder="Ticket Status" />
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-12 p-lg-12">
                        <label className="label">Comments</label>
                            <div className="mt1">
                                <InputTextarea rows={3} className="p-col-12" value={action.comments} cols={30} placeholder="Comments..." autoResize={true} />
                            </div> 
                        </div>

    
                        <div className="p-col-12 p-lg-12"><hr/></div>  
                        </div>
                    </div>
                </div>
                )
        } else if(action.actiontype === 3){
            return (
                <div className="p-col-12" key={index}>
                    <div className="card card-w-title">
                    <h1>Transport Action</h1>
                    <div className="p-grid">
    
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Transporation Date</label>
                            <div className="mt1">
                                <InputText className="p-col-12" value={action.transportationdatetime}  placeholder="Transporation Date"/>
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Transporation From</label>
                            <div className="mt1">
                                <InputText className="p-col-12" value={action.transportationfrom}  placeholder="Transporation From"/>
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Transporation To</label>
                            <div className="mt1">
                                <InputText className="p-col-12" value={action.transportationto}  placeholder="Transporation To"/>
                            </div> 
                        </div>


            
                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Transporation Status</label>
                            <div className="mt1">
                                <InputText className="p-col-12" value={status} placeholder="Ticket Status" />
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-12 p-lg-12">
                        <label className="label">Comments</label>
                            <div className="mt1">
                                <InputTextarea rows={3} className="p-col-12" value={action.comments} cols={30} placeholder="Comments..." autoResize={true} />
                            </div> 
                        </div>
    
                        <div className="p-col-12 p-lg-12"><hr/></div>  
                        </div>
                    </div>
                </div>
                )
        } else if(action.actiontype === 4){
            return (
                <div className="p-col-12" key={index}>
                    <div className="card card-w-title">
                    <h1>Iqama Action</h1>
                    <div className="p-grid">
    
                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Iqama Status</label>
                            <div className="mt1">
                                <InputText className="p-col-12" value={status} placeholder="Ticket Status" />
                            </div> 
                        </div>

                        <div className="p-col-12 p-md-12 p-lg-12">
                        <label className="label">Comments</label>
                            <div className="mt1">
                                <InputTextarea rows={3} className="p-col-12" value={action.comments} cols={30} placeholder="Comments..." autoResize={true} />
                            </div> 
                        </div>
    
                        <div className="p-col-12 p-lg-12"><hr/></div>  
                        </div>
                    </div>
                </div>
                )
        }

    });
    return actions;
}

export default viewActions;